var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('InvoiceTable',{ref:"invTable",attrs:{"query":_vm.invQuery,"showShow":"","showDownload":"","showPagination":"","noHitText":_vm.$t('tra.ino')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }